<template>
  <div class="manage-sub">
    <div
      class="plan-item"
      v-for="plan in planList"
      :key="plan.id">
      <div
        class="plan-con"
        :style="{background: plan.style.background}">
        <div class="title-wrap">
          <div class="title">{{ plan.planDisplayName }}</div>
          <div>
            <el-popover
              placement="right-end"
              title=""
              popper-class="plan-popover"
              width="80"
              trigger="click"
            >
              <div
                class="reselect"
                @click="reselectPlan('node')">{{ $t('mediahub.reselect') }}</div>
              <div
                class="reselect"
                @click="handleCancelSub(plan.planId)">{{ $t('mediahub.deactivate') }}</div>
              <svg
                slot="reference"
                class="plan-popover-icon"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect
                  opacity="0.01"
                  width="16"
                  height="16"
                  fill="black"/>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.48854 2.43801C6.98633 2.65622 6.66285 3.15312 6.66654 3.70068C6.66608 4.06086 6.80625 4.40698 7.05721 4.66534C7.30721 4.92134 7.64654 5.06468 7.99987 5.06468C8.54418 5.06139 9.03185 4.72758 9.23187 4.22134C9.43787 3.71068 9.32387 3.12334 8.94187 2.73268C8.565 2.34333 7.9873 2.2262 7.48854 2.43801ZM6.66654 8.00134C6.66285 7.45379 6.98633 6.95689 7.48854 6.73868C7.98744 6.52703 8.56515 6.64443 8.94187 7.03401C9.32387 7.42468 9.43787 8.01201 9.23187 8.52268C9.03185 9.02891 8.54418 9.36273 7.99987 9.36601C7.26387 9.36601 6.66654 8.75534 6.66654 8.00134ZM6.66654 12.3027C6.66258 11.7549 6.98611 11.2577 7.48854 11.0393C7.98744 10.8277 8.56515 10.9451 8.94187 11.3347C9.32387 11.7253 9.43787 12.3127 9.23187 12.8233C9.03185 13.3296 8.54418 13.6634 7.99987 13.6667C7.64654 13.6667 7.30721 13.5233 7.05721 13.2673C6.80625 13.009 6.66608 12.6629 6.66654 12.3027Z"
                  fill="white"/>
              </svg>
            </el-popover>
          </div>
          <!-- <div class="reselect" @click="reselectPlan('node')">Reselect Plan</div> -->
        </div>
        <!-- <div class="expiration" v-if="plan.status == 5">Expiration date: sub already expired</div>
        <div class="expiration" v-else>Expiration date: {{expireTime | transDateAndTime(3)}}</div> -->
        <div
          class="manage-pay"
          @click="managePlan(plan.id)">
          <div>{{ $t('mediahub.managed') }}</div>
        </div>
      </div>
    </div>
    <!-- 通用新增 Plan 的卡片，仅保留一张 -->
    <div class="plan-item">
      <div
        class="plan-none"
        @click="reselectPlan('cloud')">
        <div class="content-info">
          <svg
            width="16"
            height="22"
            viewBox="0 0 16 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.5 0.5V21.5L8 17L15.5 21.5V0.5H0.5ZM2 2H14V18.8047L8 15.2656L2 18.8047V2ZM8 4.1C8.41421 4.1 8.75 4.43579 8.75 4.85V7.85H11.75C12.1642 7.85 12.5 8.18579 12.5 8.6C12.5 9.01421 12.1642 9.35 11.75 9.35H8.75V12.35C8.75 12.7642 8.41421 13.1 8 13.1C7.58579 13.1 7.25 12.7642 7.25 12.35V9.35H4.25C3.83579 9.35 3.5 9.01421 3.5 8.6C3.5 8.18579 3.83579 7.85 4.25 7.85H7.25V4.85C7.25 4.43579 7.58579 4.1 8 4.1Z"
              fill="#666666"/>
          </svg>
          <span>{{ $t('mediahub.subscribeDemand') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    planList: {
      type: Array,
      default () {
        return [{}, {}]
      }
    }
  },
  inject: ['Cancel'],
  methods: {
    reselectPlan (type) {
      this.$emit('choose', type)
    },
    managePlan (type) {
      this.$emit('manage', type)
    },
    handleCancelSub (id) {
      this.Cancel(id)
    }
  },
  computed: {
    cloudPlan () {
      return this.planList.find(i => i.id === 'cloud' && i.sub)
    },
    nodePlan () {
      return this.planList.find(i => i.id === 'node' && i.sub)
    }
  }
}
</script>

<style lang="less" scoped>
.manage-sub {
  width: 408px;
  .plan-item {
    margin-bottom: 20px;
    .plan-con {
      background: linear-gradient(274.86deg, #BDCFF4 0%, #E6EDFA 100%);
      height: 134px;
      padding:30px 0 20px;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      .title-wrap {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        .plan-popover-icon {
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }
      .title {
        font-weight: 700;
        font-size: 36px;
        line-height: 36px;
        color: #444444;
      }
      .reselect {
        color: #ffffff;
        font-size: 14px;
        border: 1px solid;
        padding: 5px 8px;
        border-radius: 8px;
        cursor: pointer;
      }
      .expiration {
        text-align: left;
        margin: 40px 0 0 20px;
        color: #EC5050;
      }
      .manage-pay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.3);
        // width: 100%;
        display: flex;
        height: 42px;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        color: #ffffff;
        cursor: pointer;
      }
      .choose {
        padding: 0 30px;
        word-break: break-word;
        text-align: left;
        font-size: 16px;
        color: #EC5050;
      }
    }
    .plan-none {
      height: 134px;
      padding:30px 0 20px;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      border: 1px dashed;
      cursor: pointer;
      .content-info {
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        left: 50%;
        height: 24px;
        line-height: 24px;
        display: flex;
        align-items: center;
        span {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
